if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
console.log(this);
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              // return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              // return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          // custom code 
            if(jQuery('.bundleItemsList:checked').length > 0){
                 var jsonObj = [];
                  jQuery('.bundleItemsList:checked').each(function(){
                    var bundleId = $(this).val();
                    item = {}
                    item ["id"] = parseInt(bundleId);
                    item ["quantity"] = 1;
                    jsonObj.push(item);
                  });
                  jQuery.post('/cart/add.js', {
                    items: jsonObj
                  }).done(function(result, status, xhr) {
                  fetch('/cart.js')
                    .then(function(response) {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.json();
                      
                    })
                    .then(function(cartData) {
                      // Assuming you have a function called 'publish'
                      publish(PUB_SUB_EVENTS.cartUpdate, { cartData: cartData });
                      
                    })
                    .catch(function(error) {
                      console.error('Error fetching cart.js:', error);
                    });
                  });
            }
          // end custom code 
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            setTimeout(function() { 
            creatSlider();

        // Select the element with the 'gift-icon' class
        const giftIcon = $('.gift-icon');
        
        // Retrieve the data attributes
        const giftAdd = giftIcon.data('gift-add');
        const giftRemove = giftIcon.data('gift-remove');
        const giftId = giftIcon.data('id');
        
        // Check if 'giftAdd' is true and 'giftId' is not empty or undefined
        if (giftAdd === true && giftId) {
            addGift(giftId);
        } 
        // Check if 'giftRemove' is true and 'giftId' is not empty or undefined
        if (giftRemove === true && giftId) {
            removeGift(giftId);
        }


            },1500);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
